import { LicenseManager } from '../../../../managers/License.manager';
import { Component, OnInit, Input } from '@angular/core';
import { ssApiService } from '../../../../services/ss-api.service';
import { LicenseTransferLogArray } from '../../../../models/domain/license.transfer.log';
import { LicensePCItemArray, LicensePCItem } from '../../../../models/domain/license.pc.item';

import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { LicenseEditTransferDetailsRequest } from '../../../../models/ss-api/requests/license.edit.transfer.details.request';
import { License } from '../../../../../app/models/domain/license';
import { UserRolesService } from '../../../../services/user.roles.service';


@Component({
	selector: 'pc-limiter',
	templateUrl: './pc.limiter.component.html',
	styleUrls: ['./pc.limiter.component.scss']
})

export class PCLimiterComponent implements OnInit {
	IsBusy: boolean = false;

	@Input('licenseManager') licenseManager: LicenseManager;
	@Input('Subscriptions') Subscriptions;

	@Input('TransferDetails') TransferDetails: LicenseTransferLogArray = new LicenseTransferLogArray();


	LicensedPCs : LicensePCItemArray = new LicensePCItemArray();


	_pcCount : number = 0;
	_newLimit : number = 0;
	_ogLimit : number = 0;
	_editLimits : boolean = false;

	constructor( private API: ssApiService, private sweetAlertService: SweetAlertService, public roles: UserRolesService ) { }

	ngOnInit() {

		console.log(' my license ', this.licenseManager.License() );
		console.log('tw', this.licenseManager.License().TOSWindow);
		//this.licenseManager.License().TransferLimitPCs

	}


	TabChanged( e : any ) {
		console.log("TabChanged : " + e.index);
	}

	GetLicensePCs() {
		this.IsBusy = true;

		var licenseID = this.licenseManager.License().ID;

		var subscription = this.API.GetLicensePCs(licenseID).subscribe(result => {

			subscription.unsubscribe();

			this.IsBusy = false;

			console.log("GetLicensePCs", result);

			this.LicensedPCs = result.Data;

			this._pcCount = this.LicensedPCs.length;
			this._newLimit = this.licenseManager.License().TransferLimitPCs;
			this._ogLimit = this._newLimit;

		});
	
	}


	MakeInactive( item : LicensePCItem ) {

		this.IsBusy = true;

		this.sweetAlertService.swal({
			title: 'De-activate PC ' + item.Username + '?',
			text: 'This action cannot be un-done.',
			type: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes',
			showLoaderOnConfirm: true,
			preConfirm: () => {
				return this.API.MakeLicensePCInactive( item.LicensePCID ).toPromise();
			}
		}).then(response => {
			this.IsBusy = false;
			
			if (!response.Result) {

				this.sweetAlertService.swal({
					title: 'Error',
					text: response.Data,
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				}).then(response => {  }).catch(error => {  });

				return;
			}
			
			this.GetLicensePCs();

			this.sweetAlertService.swal({
				title: 'Success',
				text: 'PC ' + item.Username + ' has been de-activated.',
				type: 'success',
				showCancelButton: false,
				showConfirmButton: false,
				timer: 2000
			}).then(response => {  }).catch(error => {  });
  
  
		}, (dismiss) => { this.IsBusy = false; return; }); // keep this line to prevent promise error;
	}


	MakeUnavailable( item : LicensePCItem ) {

		this.IsBusy = true;

		this.sweetAlertService.swal({
			title: 'Make PC ' + item.Username + ' Un-available?',
			text: 'This action cannot be un-done.',
			type: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes',
			showLoaderOnConfirm: true,
			preConfirm: () => {
				return this.API.MakeLicensePCUnavailable( item.LicensePCID ).toPromise();
			}
		}).then(response => {
			this.IsBusy = false;
			
			if (!response.Result) {

				this.sweetAlertService.swal({
					title: 'Error',
					text: response.Data,
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				}).then(response => {  }).catch(error => {  });

				return;
			}
			
			this.GetLicensePCs();

			this.sweetAlertService.swal({
				title: 'Success',
				text: 'PC ' + item.Username + ' is now un-available.',
				type: 'success',
				showCancelButton: false,
				showConfirmButton: false,
				timer: 2000
			}).then(response => {  }).catch(error => {  });
  
  
		}, (dismiss) => { this.IsBusy = false; return; }); // keep this line to prevent promise error;

	}



	MakeAvailable ( item : LicensePCItem ) {

		this.IsBusy = true;

		this.sweetAlertService.swal({
			title: 'Make PC ' + item.Username + ' Available?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes',
			showLoaderOnConfirm: true,
			preConfirm: () => {
				return this.API.MakeLicensePCAvailable( item.LicensePCID ).toPromise();
			}
		}).then(response => {
			this.IsBusy = false;
			
			if (!response.Result) {

				this.sweetAlertService.swal({
					title: 'Error',
					text: response.Data,
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				}).then(response => {  }).catch(error => {  });

				return;
			}
			
			this.GetLicensePCs();

			this.sweetAlertService.swal({
				title: 'Success',
				text: 'PC ' + item.Username + ' is now available.',
				type: 'success',
				showCancelButton: false,
				showConfirmButton: false,
				timer: 2000
			}).then(response => {  }).catch(error => {  });
  
  
		}, (dismiss) => { this.IsBusy = false; return; }); // keep this line to prevent promise error;

	}



	Delete( item : LicensePCItem ) {
		
		this.IsBusy = true;

		this.sweetAlertService.swal({
			title: 'Delete PC Item for ' + item.Username + '?',
			text: 'This action cannot be un-done.',
			type: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, Delete',
			showLoaderOnConfirm: true,
			preConfirm: () => {
				return this.API.DeleteLicensePC( item.LicensePCID ).toPromise();
			}
		}).then(response => {
			this.IsBusy = false;
			
			if (!response.Result) {

				this.sweetAlertService.swal({
					title: 'Error',
					text: response.Data,
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				}).then(response => {  }).catch(error => {  });

				return;
			}
			
			this.GetLicensePCs();

			this.sweetAlertService.swal({
				title: 'Success',
				text: 'The PC has been deleted.',
				type: 'success',
				showCancelButton: false,
				showConfirmButton: false,
				timer: 2000
			}).then(response => {  }).catch(error => {  });
  
  
		}, (dismiss) => { this.IsBusy = false; return; }); // keep this line to prevent promise error;


	}


	UpdatePCLimit() {

		if( this._newLimit < 1 ) {
			this.sweetAlertService.swal({
				title: 'Invalid Limit Value',
				text: 'PC Limit cannot be lower than 1.',
				type: 'warning',
				showCancelButton: false,
				showConfirmButton: true,
				confirmButtonText: 'OK',
			});
			return;
		}

		this.IsBusy = true;
		this._editLimits = false;

		let myLicense : License = this.licenseManager.License();
	
		var request = new LicenseEditTransferDetailsRequest();
        request.ID = myLicense.ID; //The license's ID
        request.TransferLimitMax = myLicense.TransferLimitMax;
        request.TransferLimitInTimeMinutes = null; //For most fields, null means "no change"
        request.Note = "Transfer PC Limit Updated in License Edit Dialog"; //If you specify a note, one will be created.  Empty string means no note
        request.TransferDisabled = myLicense.TransferDisabled;
        request.TransferDisabledReason = myLicense.TransferDisabledReason;
        request.TransferLimitPCs = this._newLimit; //null or < 1 convert to 4 - we can't zero this out


		this.sweetAlertService.swal({
			title: 'Change PC Limit to ' + this._newLimit + '?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes',
			showLoaderOnConfirm: true,
			preConfirm: () => {
				return this.API.EditTransferDetails(request).toPromise();
			}
		}).then(response => {
			this.IsBusy = false;
			
			if (!response.Result) {

				this.sweetAlertService.swal({
					title: 'Error',
					text: response.Data,
					type: 'error',
					showCancelButton: false,
					showConfirmButton: true
				}).then(response => {  }).catch(error => {  });

				return;
			}
			
			this.GetLicensePCs();
			this.licenseManager.License().TransferLimitPCs = this._newLimit;
			
			this.sweetAlertService.swal({
				title: 'Success',
				text: 'The PC Transfer Limit has been updated',
				type: 'success',
				showCancelButton: false,
				showConfirmButton: false,
				timer: 2000
			}).then(response => {  }).catch(error => {  });
  
  
		}, (dismiss) => { this.IsBusy = false; return; }); // keep this line to prevent promise error;

	}

	CancelPCLimitUpdate() {
		this._newLimit = this._ogLimit;
		this._editLimits = false;
	}




}
